import { useEffect } from 'react';

const useLockBodyScroll = (enabled: boolean, isLaptop?: boolean): void => {
  useEffect(() => {
    if (isLaptop) return undefined;
    if (!document || !enabled) return undefined;

    const { style } = document.body;

    style.setProperty('overflow', 'hidden');

    return () => {
      style.removeProperty('overflow');
    };
  }, [enabled, isLaptop]);
};

export default useLockBodyScroll;
